import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  sidebarMobileOpen: boolean;
  rightDrawerOpen: boolean;
  rightDrawerContent: 'notifications' | 'ai-chat' | 'lead-detail' | null;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleMobileSidebar: () => void;
  closeMobileSidebar: () => void;
  openRightDrawer: (content: UIState['rightDrawerContent']) => void;
  closeRightDrawer: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      sidebarMobileOpen: false,
      rightDrawerOpen: false,
      rightDrawerContent: null,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      toggleMobileSidebar: () => set((state) => ({ sidebarMobileOpen: !state.sidebarMobileOpen })),
      closeMobileSidebar: () => set({ sidebarMobileOpen: false }),
      openRightDrawer: (content) => set({ rightDrawerOpen: true, rightDrawerContent: content }),
      closeRightDrawer: () => set({ rightDrawerOpen: false, rightDrawerContent: null }),
    }),
    { name: 'lum-ui-storage', partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }) },
  ),
);